const COOKIE_NAME = "website_thread_id";
const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN || "inhouse.ai";

/**
 * The domain-wide `website_thread_id` cookie is written by the marketing site
 * (inhouse.ai). The platform only drains it: its IDs are moved into the
 * localStorage `thread_ids` history by `migrateLegacyThreadStores`, then the
 * cookie is cleared. The platform never writes it.
 */

const readRawCookie = (): string | null => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

/**
 * Accepts both formats. The marketing site writes a single ID; older platform
 * bundles wrote a JSON array. A value that doesn't parse as an array is a
 * single ID and gets wrapped.
 */
export function getWebsiteThreadIds(): string[] {
  const raw = readRawCookie();
  if (!raw) {
    return [];
  }
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return parsed.filter((entry): entry is string => typeof entry === "string" && entry.length > 0);
    }
  } catch {
    // Not JSON — fall through to the single-value reading.
  }
  return [raw];
}

/**
 * Expire the cookie. Domain and path must match how the marketing site set it,
 * or the browser treats this as a different cookie and leaves the original.
 */
export function clearWebsiteThreadIds(): void {
  document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${BASE_DOMAIN}; SameSite=Lax`;
}
